import './tailwind.css';
import { FunctionComponent } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter} from 'react-router-dom';
import store from '~/store';
import { AuthRoutes } from './resources/routes/AuthRoutes';


const App: FunctionComponent = () => {
  return (
    <div className="text-theme-gray">
      <Provider store={store}>
        <BrowserRouter>
          <AuthRoutes />
        </BrowserRouter>
      </Provider>
    </div>
  );
};
export default App;